const dateToFirebaseDate = (date) => {
    if (!(date instanceof Date)){
        return null;
    }

    return {seconds: date.getTime() / 1000, nanoseconds: 0};
};

export default dateToFirebaseDate;